import styled from "styled-components";

export const Container = styled.div`
    margin-bottom: 40px;
    button {
        width: fit-content;
        padding: 0px 20px;
    }
`;
